window.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('#leather-section') == null) {
        const leatherLink = document.querySelector('.leather-link')
        if (leatherLink != null) {
            leatherLink.style.display = 'none'
        }
    }

    let isBundle = false

    if (document.querySelector('.template-bundle') != null) {
        isBundle = true
    }

    if (!isBundle) { // materialsModalAddToCart()
        displayMessages()
    }

    let isGiftCard = false

    if (document.querySelector('.template-giftcard') != null) {
        isGiftCard = true
    }
    // product details slideout

    // get vimeo container if it exists

    let productHasVideo = false

    const vimeoContainer = document.querySelector('.vimeo-container')

    if (vimeoContainer != null) {
        productHasVideo = true

        const vimeoIframe = vimeoContainer.querySelector('iframe');
        if (vimeoIframe != null) {
            vimeoContainer.querySelector('iframe').click()
        }
    }

    if (productHasVideo) {
        const imageContatiner = document.querySelector('.grid--product-images--partial')
        const dotContainer = imageContatiner.querySelector('.flickity-page-dots')
        const dots = dotContainer.querySelectorAll('li')
        dots.forEach((dot, index) => {
            if (index == dots.length - 1) {
                dot.innerText = '▶'
                dot.setAttribute('style', 'background-color:transparent; font-size: 12px; margin-bottom:5px;')
            }
        })
    }
    const seeProductDetailsButton = document.querySelectorAll('.see-details-link')
    for(let i = 0; i < seeProductDetailsButton.length; i++){

        seeProductDetailsButton[i].addEventListener('click', () => {
            const detailsModal = document.querySelector('.details-modal')
            if (seeProductDetailsButton[i].classList.contains('active-link')) {
                const drawer = detailsModal.querySelector('.modal-content')
                if (window.matchMedia("(max-width: 1024px)").matches) {
                    seeProductDetailsButton[i].classList.remove('active-link')
                    detailsModal.style.display = 'none'
                } else {
                    detailsModal.style.display = 'block'
                    setTimeout(() => {
                        drawer.style.right = '0px'
                    }, 100)
                }
            } else {
                detailsModal.style.display = 'block'
                seeProductDetailsButton[i].classList.add('active-link')

                // const shippingModal = document.querySelector('.shipping-modal')
                // const customerServiceModal = document.querySelector('.customer-service-modal')
                // if (window.matchMedia("(max-width: 1024px)").matches){
                //     shippingModal.style.height = '0px'
                //     customerServiceModal.style.height = '0px'
                // }

                // shippingModal.style.display = 'none'
                // customerServiceModal.style.display = 'none'

                const drawer = detailsModal.querySelector('.modal-content')
                if (window.matchMedia("(min-width: 1024px)").matches) {
                    setTimeout(() => {
                        drawer.style.right = '0px'
                    }, 100)
                } else {
                    setTimeout(() => {
                        if(window.innerWidth > 769){
                            detailsModal.style.height = '100%'
                        }else{
                            detailsModal.style.height = 'auto'
                        }
                    }, 100)
                }
                $('.pairs-well-slideshow').slick('setPosition');
            }


        })

    }
    const seeMaterialsButton = document.querySelectorAll('.see-all-materials-link')
    if (seeMaterialsButton != null) {
        for (let j = 0; j < seeMaterialsButton.length; j++) {
            seeMaterialsButton[j].addEventListener('click', () => {
                const materialsModal = document.querySelectorAll('.materials-modal')
                for (let i = 0; i < materialsModal.length; i++) {
                    materialsModal[i].style.display = 'block'
                    const drawer = materialsModal[i].querySelector('.modal-content')
                    setTimeout(() => {
                        drawer.style.right = '0px'
                    }, 100)
                }

            })
        }
    }

    // Only run the ajax JS if the product is NOT mainline or GO
    const mainlineProductTemplate = document.querySelector('.mainline-product-section') 
    if(!mainlineProductTemplate || mainlineProductTemplate.length == 0){

        // ajax functionality
        const productSwatches = document.querySelectorAll('.custom-product-swatch')
        let productSection = document.querySelector('.product-section')
        let productId = productSection.getAttribute('data-variant-id')

        if (productSwatches.length > 0) {

            productSwatches.forEach(productSwatch => {

                const label = productSwatch.querySelector('label')

                // select correct input on page load
                if (productSwatch.getAttribute('data-id') == productId) {
                    label.classList.add('active')
                    displayMessages()
                }

                if (!isBundle && !isGiftCard) { // get the product we clicked on
                    productSwatch.addEventListener('click', (e) => ajaxUpdate(e, productHasVideo))
                    productSwatch.addEventListener('keypress', (e) => {
                        if (e.keyCode === 13) {
                            ajaxUpdate(e, productHasVideo)
                        }
                    })
                }
            })
        }
    }
})

function ajaxUpdate(e, productHasVideo)  { // Dev note: When submitting ATC the button has a data attribute card-variant-id, the variant ID needs to be updated
    const productSwatch = e.target;
    const selectedSwatch = productSwatch.closest('div.custom-product-swatch');
    const label = selectedSwatch.querySelector('label'); 

if (!selectedSwatch) {
    console.error('No element with class .custom-product-swatch found');
    return;
}

const productBlock = selectedSwatch.closest('.product-block');
if (!productBlock) {
    console.error('No element with class .product-block found');
    return;
}

const currentColorElement = productBlock.querySelector('.current-color');
if (!currentColorElement) {
    console.error('No element with class .current-color found');
    return;
}

const dataElement = selectedSwatch.closest('[data-product-blocks]')
    ?.querySelector('form button[type="submit"]');

if (dataElement) {
    dataElement.dataset.cardVariantId = selectedSwatch.dataset.id;
} else {
    console.error('No data element found');
}

if ($(selectedSwatch).parents('.group-b-test-wrap').length) {
    const mainProductLeatherType = selectedSwatch.getAttribute("data-leather-type");
    if (mainProductLeatherType && mainProductLeatherType !== '') {
        currentColorElement.innerHTML = `${selectedSwatch.getAttribute('data-value')} in ${mainProductLeatherType}`;
    }
} else {
    currentColorElement.innerHTML = selectedSwatch.getAttribute('data-value');
}

    // highlight selected swatch
    deselectLabels()

    setTimeout(() => {
        if(label) {
            label.classList.add('active')
        }
        // custom messages on click
        displayMessages()
    }, 100)
    const productHandle = selectedSwatch.getAttribute('data-handle')
    const url = window.location.href
    fetch(url.split('products/')[0] + 'products/' + productHandle + '.json').then(response => response.json()).then(data => {
        // debugger
        // product is set to the product object
        const product = data.product
        // update url
        window.history.pushState('', '', url.split('products/')[0] + 'products/' + product.handle + '?variant=' + product.variants[0].id);

        // update price
        const compareAtPrice = product.variants[0].compare_at_price
        const price = product.variants[0].price
        const savings = parseFloat(compareAtPrice - price)
        if (compareAtPrice != '') {

            const priceBlocks = document.querySelectorAll('.product-block--price')
            for (let i = 0; i < priceBlocks.length; i++) {
                priceBlocks[i].innerHTML = `
                    <span data-a11y-price="" class="visually-hidden" aria-hidden="false">
                    Regular price
                    </span>
                    <span data-product-price-wrap="" class="">
                    <span data-compare-price="" class="product__price product__price--compare">$ ${compareAtPrice}
                        </span>
                    </span>
                <span data-compare-price-a11y="" class="visually-hidden">Sale price</span><span data-product-price="" class="product__price on-sale">$ ${price}
                    </span><span data-save-price="" class="product__price-savings">Save $ ${
                    savings.toFixed(2)
                }
                    </span><div data-unit-price-wrapper="" class="product__unit-price product__unit-price--spacing  hide"><span data-unit-price=""></span>/<span data-unit-base=""></span>
                                    </div>
                    `
            }

        } else {
            const priceBlocks = document.querySelectorAll('.product-block--price')
            for (let i = 0; i < priceBlocks.length; i++) {
                priceBlocks[i].innerHTML = `
                    <span data-a11y-price="" class="visually-hidden">Regular price</span><span data-product-price="" class="product__price">$ ${price}
                    </span><span data-save-price="" class="product__price-savings hide"></span><div data-unit-price-wrapper="" class="product__unit-price product__unit-price--spacing  hide"><span data-unit-price=""></span>/<span data-unit-base=""></span>
                                        </div
                    `
            }
        }
        // update images
        const imageContatiner = document.querySelector('.grid--product-images--partial')
        const productSlideshow = imageContatiner.querySelector('.product-slideshow')
        const productImagesArray = product.images.map(image => image.src)

        const flickity = imageContatiner.querySelector('.flickity-viewport')

        const swatchClicked = new CustomEvent("swatchClicked");
        document.dispatchEvent(swatchClicked);
        //    if coming from flickity
        if (flickity != null) {
            productSlideshow.classList.remove('flickity-enabled')
            productSlideshow.classList.remove('is-draggable')
            flickity.remove()
        }

        // update atc
        if (label.classList.contains('disabled')) {

            const atcForm = document.querySelector('.atc-block')
            const formOption = atcForm.querySelector("option")
            formOption.removeAttribute('value')
            formOption.removeAttribute('selected')

            formOption.innerText = `${
                product.title
            } - Sold Out`

            const atcButton = atcForm.querySelector('.add-to-cart')
            atcButton.setAttribute('disabled', 'disabled')
            atcButton.classList.add('disabled')
            atcButton.innerText = 'Sold Out'
            productJSON = document.querySelector('[aria-label="Product JSON"]')
            productJSON.innerText = JSON.stringify([{
                    "id": product.variants.id,
                    "title": product.options.values[0],
                    "option1": product.options.values[0],
                    "option2": product.options.values[1],
                    "option3": product.options.values[2],
                    "sku": product.variants[0].sku,
                    "requires_shipping": product.variants[0].requires_shipping,
                    "taxable": product.variants[0].taxable,
                    "featured_image": null,
                    "available": true,
                    "name": "Sheila Buffed Hide Whiskey - Whiskey",
                    "public_title": "Whiskey",
                    "options": ["Whiskey"],
                    "price": 38800,
                    "weight": 12338,
                    "compare_at_price": null,
                    "inventory_management": "shopify",
                    "barcode": product.variants[0].barcode
                }])

            const productForm = atcForm.querySelector('.product-single__form')
            productForm.setAttribute('id', productForm.getAttribute('id').split('main')[0] + 'main-' + product.id)
 
            window.location.reload()
        } else {
            const atcForm = document.querySelector('.atc-block')
            const formOption = atcForm.querySelector("option")
            formOption.setAttribute('selected', 'selected')
            formOption.removeAttribute('disabled')

            formOption.setAttribute('value', product.variants[0].id)
            formOption.innerText = `${
                product.title
            } - ${
                product.variants[0].price
            } USD`


            productJSON = document.querySelector('[aria-label="Product JSON"]')
            productJSON.innerText = JSON.stringify([{
                    "id": product.variants.id,
                    "title": product.options.values[0],
                    "option1": product.options.values[0],
                    "option2": product.options.values[1],
                    "option3": product.options.values[2],
                    "sku": product.variants[0].sku,
                    "requires_shipping": product.variants[0].requires_shipping,
                    "taxable": product.variants[0].taxable,
                    "featured_image": null,
                    "available": true,
                    "name": "Sheila Buffed Hide Whiskey - Whiskey",
                    "public_title": "Whiskey",
                    "options": ["Whiskey"],
                    "price": 38800,
                    "weight": 12338,
                    "compare_at_price": null,
                    "inventory_management": "shopify",
                    "barcode": product.variants[0].barcode
                }])

            const atcButton = atcForm.querySelector('.add-to-cart')
            atcButton.removeAttribute('disabled')
            atcButton.classList.remove('disabled')

            atcButton.innerText = 'Add To Bag'
            const productForm = atcForm.querySelector('.product-single__form')
            productForm.setAttribute('id', productForm.getAttribute('id').split('main')[0] + 'main-' + product.id)

        }

        // update images
        if (imageContatiner.length > 0) {
            imageContatiner = document.querySelector('.grid--product-images--partial')
            productSlideshow = imageContatiner.querySelector('.product-slideshow')
            productImagesArray = product.images.map(image => image.src)

            flickity = imageContatiner.querySelector('.flickity-viewport')
        } else {
            const imageContatiner = document.querySelector('.grid--product-images--partial')
            const productSlideshow = imageContatiner.querySelector('.product-slideshow')
            const productImagesArray = product.images.map(image => image.src)

            const flickity = imageContatiner.querySelector('.flickity-viewport')
        }
        //    if coming from flickity
        if (flickity != null) {
            productSlideshow.classList.remove('flickity-enabled')
            productSlideshow.classList.remove('is-draggable')
            flickity.remove()
        }

        // single image no thumbnails
        let imageWrap = imageContatiner.querySelector('.image-wrap')
        if (product.images.length <= 1) {

            if (imageContatiner.querySelector('.product-slide') != null) { // if coming from slick slideshow
                imageContatiner.querySelectorAll('.product-slide').forEach(productSlide => {
                    productSlide.remove()
                    if (imageContatiner.querySelector('.slick-dots')) {
                        imageContatiner.querySelector('.slick-dots').remove()
                    }
                })
                document.querySelector('.slick-list').remove()
                productSlideshow.classList.remove('slick-initialized', 'slick-slider', 'slick-dotted')
                productSlideshow.insertAdjacentHTML('beforeend', `
                            <div class="product-main-slide starting-slide is-selected" data-index="0">
                                <div data-product-image-main="" class="product-image-main">
                                <div class="image-wrap" style="height: 0; padding-bottom: 100.0%;">
                                <img class="photoswipe__image lazyautosizes lazyloaded" 
                                data-photoswipe-src="//cdn.shopify.com/s/files/1/0636/4223/9224/products/BF-35019LGNA_01_1800x1800.jpg?v=1649881381"
                                data-photoswipe-width="1425" data-photoswipe-height="1425"
                                data-index="1" 
                                data-aspectratio="1.0" 
                                data-sizes="auto" 
                                alt="${
                    product.images[0].title
                }"
                                data-src="${
                    product.images[0].src
                }" 
                                sizes="545px" 
                                srcset="${
                    product.images[0].src
                }"
                                >

                                        <noscript>
                                        <img class="lazyloaded"
                                            src="${
                    product.images[0].src
                }"
                                            alt="${
                    product.images[0].title
                }">
                                        </noscript><button onClick="openPhotoSwipeZoom('${
                    product.images[0].src
                }','${productImagesArray}')" type="button" class="btn btn--body btn--circle js-photoswipe__zoom product__photo-zoom">
                                            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-search" viewBox="0 0 64 64"><path d="M47.16 28.58A18.58 18.58 0 1 1 28.58 10a18.58 18.58 0 0 1 18.58 18.58zM54 54L41.94 42"></path></svg>
                                            <span class="icon__fallback-text">Close (esc)</span>
                                        </button></div></div>

                                </div>
                            `)

            } else { // coming from another single photo
                if (imageContatiner.querySelector('.photoswipe__image') != null) {
                    if (imageWrap.querySelector('.photoswipe__image').getAttribute('src') != product.images[0].src) {


                        productSlideshow.innerHTML = ''
                        productSlideshow.insertAdjacentHTML('afterbegin', `
                        <div class="image-wrap" style="height: 0; padding-bottom: 100.0%;">
                        <img class="photoswipe__image
                        lazyautosizes lazyloaded"
                        data-photoswipe-src="${
                            product.images[0].src
                        }" 
                        data-photoswipe-width="1425"
                        data-photoswipe-height="1425" data-index="1" 
                        data-aspectratio="1.0" 
                        alt="${
                            product.title
                        }"
                        data-src="${
                            product.images[0].src
                        }"
                        src="${
                            product.images[0].src
                        }"/>
                        <noscript>
                        <img class="lazyloaded"
                            src="${
                            product.images[0].src
                        }"
                            alt="${
                            product.title
                        }">
                        </noscript>
                        <button type="button" onClick="openPhotoSwipeZoom('${
                            product.images[0].src
                        }', '${productImagesArray}')" class="btn btn--body btn--circle js-photoswipe__zoom product__photo-zoom">
                            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-search" viewBox="0 0 64 64"><path d="M47.16 28.58A18.58 18.58 0 1 1 28.58 10a18.58 18.58 0 0 1 18.58 18.58zM54 54L41.94 42"></path></svg>
                            <span class="icon__fallback-text">Close (esc)</span>
                        </button>
                        </div>
                        `)
                    }
                }
            }

        } else { // product selected has multiple images
            const firstImage = document.querySelectorAll('.photoswipe__image')[0]
            if (firstImage == null || firstImage.getAttribute('src').split('v=')[1] != product.images[0].src.split('v=')[1]) {

                if (imageContatiner.querySelector('.product-slide') != null) {
                    productSlideshow.classList.remove('slick-initialized', 'slick-slider', 'slick-dotted')
                }

                const imageWrap = imageContatiner.querySelector('.image-wrap')
                imageWrap.remove()

                productSlideshow.innerHTML = ""
                product.images.forEach((image, index) => {

                    productSlideshow.insertAdjacentHTML('beforeend', `
                            <div class="product-image-main product-slide"><div class="image-wrap" style="height: 0; padding-bottom: 100.0%;">
                            <img class="photoswipe__image lazyautosizes lazyloaded" data-photoswipe-src="${
                        image.src
                    }" 
                            data-photoswipe-width="1425" data-photoswipe-height="1425" 
                        
                            data-aspectratio="1.0" 
                            data-sizes="auto" alt="${
                        image.alt
                    }"
                            data-src="${
                        image.src
                    }"
                            src="${
                        image.src
                    }">

                                    <noscript>
                                    <img class="lazyloaded"
                                        src="${
                        image.src
                    }"
                                        alt="${
                        image.alt
                    }">
                                    </noscript><button onClick="openPhotoSwipeZoom('${
                        product.images[0].src
                    }', '${productImagesArray}', '${index}')" type="button" class="btn btn--body btn--circle js-photoswipe__zoom product__photo-zoom">
                                        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-search" viewBox="0 0 64 64"><path d="M47.16 28.58A18.58 18.58 0 1 1 28.58 10a18.58 18.58 0 0 1 18.58 18.58zM54 54L41.94 42"></path></svg>
                                        <span class="icon__fallback-text">Close (esc)</span>
                                    </button></div></div>
                                `)

                })

                if (productHasVideo) {

                    productSlideshow.insertAdjacentHTML('beforeend', `
                                <div class="product-image-main product-slide vimeo-wrapper">
                                <div class="vimeo-container">
                                ${
                        vimeoContainer.innerHTML
                    }
                                </div>
                                </div
                                `)
                }

                $('.product-slideshow').slick({
                    dots: true,
                    arrows: true,
                    infinite: true,
                    prevArrow: "<button type='button' class='slick-prev flickity-button flickity-prev-next-button flickity-previous'><svg class='flickity-button-icon' viewBox='0 0 100 100'><path d='M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z' class='arrow'></path></svg></button>",
                    nextArrow: "<button type='button' class='slick-next flickity-button flickity-prev-next-button flickity-next'><svg class='flickity-button-icon' viewBox='0 0 100 100'><path d='M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z' class='arrow' transform='translate(100, 100) rotate(180) '></path></svg></button>"
                })

                const dotContainer = imageContatiner.querySelector('.slick-dots')
                if (dotContainer != null) {
                    const dots = dotContainer.querySelectorAll('li')
                    if (productHasVideo) {
                        dots.forEach((dot, index) => {
                            if (index == dots.length - 1) {
                                dot.innerText = '▶'
                                dot.setAttribute('style', ' font-size: 12px; margin-top: 5px;')

                            } else {
                                dot.innerText = '●'
                            }
                        })
                    } else {
                        dots.forEach((dot, index) => {
                            dot.innerText = '●'

                        })
                    }
                }
            }
        }
    })
}

function deselectLabels() {
    const productSwatches = document.querySelectorAll('.custom-product-swatch')
    productSwatches.forEach(swatch => {
        swatch.querySelector('label').classList.remove('active')
    })
}

function openPhotoSwipeZoom(productFirstImageSrc, productImagesArray, clickedIndex) {
    const imageArray = productImagesArray.split(',')


    document.querySelectorAll('.pswp__zoom-wrap').forEach(image => {
        image.remove()
    })

    const photoSwipeBackground = document.querySelector('.pswp__bg')
    const photoSwipeContainer = document.querySelector('.pswp')
    const photoSwipeUI = document.querySelector('.pswp__ui')
    photoSwipeContainer.classList.add('pswp--supports-fs', 'pswp--open', 'pswp--notouch', 'pswp--css_animation', 'pswp--svg', 'pswp--zoom-allowed', 'pswp--visible', 'pswp--animated-in')
    photoSwipeContainer.setAttribute('style', 'position: fixed')
    photoSwipeBackground.setAttribute('style', 'opacity:1')
    photoSwipeUI.classList.remove('pswp__ui--hidden')

    const photoContainer = document.querySelector('.pswp__container')


    photoContainer.innerHTML = ''

    imageArray.forEach(image => {

        if (image.includes('https:')) {
            image = image.split('https:')[1]
        } else {
            image = image.split('http:')[1]

        } photoContainer.insertAdjacentHTML('beforeend', `<div class="zoomed-img-slide">
        <img class='slide-image' src="${
            image.split('.jpg')[0] + '_1800x1800.jpg' + image.split('.jpg')[1]
        }">
        </div>`)

    })

    if (imageArray.length > 1) {
        $('.pswp__container').slick({
            nextArrow: $('.pswp__button--arrow--right'),
            prevArrow: $('.pswp__button--arrow--left'),
            asNavFor: $('.product-slideshow'),
            useTransform: false,
            fade: true
        })
    }

    $('.pswp__container').slick('slickGoTo', clickedIndex)

    document.querySelector('.pswp__button--close').setAttribute('onClick', 'closePhotoSwipeZoom()')

    photoSwipeContainer.addEventListener('click', event => {
        if (event.target.getAttribute('class').includes('pswp__ui') || event.target.getAttribute('class').includes('zoomed-img-slide ')) {
            closePhotoSwipeZoom()
        }
    })

    // zoom on click on the image
    document.querySelectorAll('.slide-image').forEach(image => {
        image.addEventListener('click', () => {
            if (image.classList.contains('zoomed')) {
                image.classList.remove('zoomed')
            } else {
                image.classList.add('zoomed')
            }
        })
    })
}

function closePhotoSwipeZoom() {
    const photoSwipeBackground = document.querySelector('.pswp__bg')
    const photoSwipeContainer = document.querySelector('.pswp')
    const photoContainer = document.querySelector('.pswp__container')
    photoContainer.classList.remove('slick-initialized', 'slick-slider')

    photoSwipeContainer.classList.remove('pswp--supports-fs', 'pswp--open', 'pswp--notouch', 'pswp--css_animation', 'pswp--svg', 'pswp--zoom-allowed', 'pswp--visible', 'pswp--animated-in')
    photoSwipeContainer.removeAttribute('style')
    photoSwipeBackground.removeAttribute('style')
}

function materialsModalAddToCart() {
    const materialSlideOut = document.querySelector('.materials-modal')
    const materialsModalATCs = materialSlideOut.querySelectorAll('.add-to-cart')
    materialsModalATCs.forEach(materialsModalATC => {
        materialsModalATC.addEventListener('click', event => { // debugger
            materialsModalATC.querySelector('span').innerText = 'Adding...'

            event.preventDefault();

            var form = event.target.closest('form');
            var data = theme.utils.serialize(form);

            fetch(theme.routes.cartAdd, {
                method: 'POST',
                body: data,
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'X-Requested-With': 'XMLHttpRequest'
                }
            }).then(response => response.json()).then(function (data) {
                if (data.status === 422) {
                    this.error(data);
                    materialsModalATC.querySelector('span').innerText = 'Error'
                } else {
                    var product = data;

                    const mainContent = document.querySelector('.main-content')
                    mainContent.classList.add('block-overlay')

                    materialsModalATC.querySelector('span').innerText = 'Added!'
                    materialsModalATC.classList.add('added')

                    // this.success(product);
                    document.dispatchEvent(new CustomEvent('cart:build'));
                    document.dispatchEvent(new CustomEvent('cart:open'));
                    setTimeout(() => {
                        materialsModalATC.querySelector('span').innerText = 'Add to bag'
                        materialsModalATC.classList.remove('added')
                    }, 2000)
                }

            }.bind(this));
        })
    })
}

function displayMessages() {
    let isGroupB = false
    let activeSwatchHandle
    if($('.group-a-test-wrap') && $('.group-a-test-wrap').css('display') == 'none'){
        // If test group B is showing, remove active class from swatch in group A to avoid double functions running 
        isGroupB = true
        $(".group-a-test-wrap label.active").removeClass('active')
        activeSwatchHandle = $('.group-b-test-wrap label.active').parent().attr('data-handle')
    }else{
        $(".group-b-test-wrap label.active").removeClass('active')
        activeSwatchHandle = $('.group-a-test-wrap label.active').parent().attr('data-handle')
    }
   
    let selectedValue = $('label.active').attr('data-variant-id')
    function toggleMessages(el) {
        if ($(el).attr('data-handle') == activeSwatchHandle) {
            $(el).show()
        } else {
            $(el).hide()
        }
    }
    if(isGroupB){
        $('.group-b-test-wrap .custom-message-container').each(function (index, el) {
            toggleMessages(el)
        });
    }else{
        $('.group-a-test-wrap .custom-message-container').each(function (index, el) {
            toggleMessages(el)
        })
    }
    

    if ($('label.active').hasClass('disabled')) {
        $('button[data-add-to-cart]').hide()
    } else {
        const customMessages =  $('.custom-message-bottom')
        for(let i = 0; i < customMessages.length; i++){
            $(customMessages[i]).show()
        }
        if($('button[data-add-to-cart]')){
            if($('button[data-add-to-cart]').hasClass('sold-out')){

                $('button[data-add-to-cart]').show()
                $('button[data-add-to-cart]').prop('disabled', '')
                $('.atc-block [data-product-select] option').attr('value', selectedValue)
                $('.atc-block [data-product-select] option').attr('selected', 'selected') 
                $('#BIS_trigger').hide();
            }
        }
    } 
};
